import { createContext } from 'react'

export type Variant = 'dark'

interface ISelectContext {
  variant?: Variant
  value: string
}

export const SelectContext = createContext<ISelectContext>({} as ISelectContext)
